import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as tagActions from '../../../../../actions/tagAction';
import TagGroupDetail from './TagGroupDetail';

const mapStateToProps = state => {
  return {
    tagGroupDetailState: state.tagGroupDetailReducer,
    tagGroupState: state.tagGroupReducer,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListTagGroupDetails: (params) => dispatch(tagActions.getListTagGroupDetails(params)),
    getAllTagGroup: () => dispatch(tagActions.getAllTagGroup()),
    deleteTagGroupDetail: (tagGroupDetail, refreshParams) => dispatch(tagActions.deleteTagGroupDetail(tagGroupDetail, refreshParams)),
  }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TagGroupDetail));
